import { Component, OnInit } from '@angular/core';
import { DocumentsRepositoryService } from '../../services/documents-repository.service';
import { DwComponent, DwComponentType, DwRoutingService } from '@devwareapps/devware-cap';
import { DocumentsManagerService } from '../../services/documents-manager.service';
import { DocumentFolderEntity, DocumentGroupEntity } from '../../../../meta-data/app-meta-data.service';
import { DocumentCardData, DocumentCardType } from '../../models/document-card-data.model';
import { DocumentSheetService } from '../../services/document-sheet.service';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';


@DwComponent({
  componentType: DwComponentType.pageComponent,
  key: 'documents-page',
  name: 'Documents Page',
  isGlobal: true
})
@Component({
  selector: 'app-documents-page',
  templateUrl: './documents-page.component.html',
  styleUrls: ['./documents-page.component.scss']
})
export class DocumentsPageComponent implements OnInit {
  documentGroupId: number;
  documentFolderId?: number;
  documentsGroup: DocumentGroupEntity;
  documentCards: DocumentCardData[] = [];
  allDocumentCards: DocumentCardData[] = [];
  documentFolder: DocumentFolderEntity;

  selectedCardUniqueKey: string;
  viewingDocument: boolean;
  documentItemId: number;

  canEditFolder: boolean = false;

  loading = false;

  constructor(
    private documentRepositoryService: DocumentsRepositoryService,
    private documentManagerService: DocumentsManagerService,
    private dwRoutingService: DwRoutingService,
    private documentSheetService: DocumentSheetService,
    private router: Router

  ) { }

  ngOnInit(): void {
    this.setupDocuments();
    this.setupEvents();
  }

  setupDocuments() {
    this.documentGroupId = this.documentManagerService.determineDocumentGroup();

    this.loading = true;
    this.documentRepositoryService.getDocumentGroup(this.documentGroupId).subscribe(documentsGroup => {
      this.documentsGroup = documentsGroup;

      this.allDocumentCards = this.documentManagerService.buildAllDocumentCards(this.documentsGroup);

      this.setupCurrentFolder();

      this.canEditFolder = this.documentManagerService.canEditFolder(documentsGroup, this.documentFolder);

      this.loading = false;
    });

    this.documentSheetService.documentDataUpdated$.subscribe((dataUpdate) => {
      this.allDocumentCards = this.documentManagerService.handleDocumentDataUpdate(dataUpdate, this.documentsGroup);
      this.setupCurrentDocumentCards();
    });


  }

  setupEvents() {
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event) => {
      this.setupCurrentFolder();
    });
  }

  setupCurrentFolder() {
    this.documentFolder = this.documentManagerService.determineCurrentFolder(this.allDocumentCards);
    this.documentFolderId = this.documentFolder?.DocumentFolderId;
    this.canEditFolder = this.documentManagerService.canEditFolder(this.documentsGroup, this.documentFolder);

    this.viewingDocument = this.documentManagerService.isViewingDocument();

    if (this.viewingDocument) {
      this.documentItemId = this.documentManagerService.getDocumentItemIdFromUrl();
    }

    this.setupCurrentDocumentCards();
  }

  cardClick(card: DocumentCardData) {
    this.documentManagerService.navigateToDocument(card, this.allDocumentCards);
  }

  cardConfigureClick(card: DocumentCardData) {

    this.selectedCardUniqueKey = card.uniqueKey;
    this.documentSheetService.openSheet(card);
  }

  addDocument() {
    const newCardData: DocumentCardData = {
      documentCardType: DocumentCardType.documentItem,
      uniqueKey: '-1',
      newItem: true,
      parentFolderId: this.documentFolderId,
      groupOrder: -1
    };

    this.documentSheetService.openSheet(newCardData);
  }

  
  addFolder() {
    const newCardData: DocumentCardData = {
      documentCardType: DocumentCardType.folder,
      uniqueKey: '-1',
      newItem: true,
      parentFolderId: this.documentFolderId,
      groupOrder: -1
    };

    this.documentSheetService.openSheet(newCardData);
  }

  setupCurrentDocumentCards() {
    this.documentCards = this.documentManagerService.getCurrentDocumentCards(this.allDocumentCards, this.documentFolderId);
  }

  // Context-aware empty state messaging
  get emptyStateTitle(): string {
    return this.documentFolderId 
      ? 'This folder is empty' 
      : 'No documents yet';
  }

  get emptyStateMessage(): string {
    return this.documentFolderId
      ? 'Add documents or create subfolders to organize your content.'
      : 'Get started by creating your first folder or uploading a document.';
  }

  // Check if we're on the protools route
  get isProtools(): boolean {
    return this.router.url.includes('/protools');
  }

}
